import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de inoculantes
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Inoculantes(props) {
  useEffect(() => {
    const title = 'inoculantes.inoculantes';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.INOCULANTE}
      insumoURL='inoculantes'
      viewKey='inoculantes'
      deleteMessageSucess={formatMessage('inoculantes.inoculantesRemovidoComSucesso')}
      mensagemFalhaDeletar={formatMessage('inoculantes.falhaAoExcluirInoculantes')}
      mensagemDelete={formatMessage('inoculantes.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'inoculantes';
  })[0].content
});

export default connect(mapStateToProps)(Inoculantes);
